window.addEventListener('DOMContentLoaded', function() {
  //"no operation" elements do nothing when clicked
  document.addEventListener('click', (event) => {
    if (event.target.closest('.js-noop')) {
      event.preventDefault();
      return false;
    }
  });
});
